import React from 'react';
import FormLayout from '@firsttable/web-components/organisms/Forms/FormLayout';
import { Field } from 'formik';
import parse, { domToReact } from 'html-react-parser';
import { Link } from '@firsttable/web-components/atoms';
import FormField from '@firsttable/web-components/molecules/FormField/FormField';
import { TrackProvider } from '@/components/analytics/context/AnalyticsContext';
import NavLink from '../../GatsbyLinkConvertor';
import { getKeyValuePair } from '../../../lib/utils';
import SuburbIdsField from './Fields/SuburbIdsField';

// [key: string]: string
export const parseContent: any = (content) =>
  !content || typeof content !== 'string'
    ? content
    : parse(content, {
        replace(node: any) {
          const { children, name: tagName } = node;
          switch (tagName) {
            case 'a': {
              return (
                <TrackProvider
                  link_copy={typeof children === 'string' ? children : undefined}
                  link_name="dynamic form link">
                  <Link
                    NavComponent={NavLink}
                    href={node.attribs.href}
                    target={node.attribs.target}
                    underline>
                    {domToReact(children)}
                  </Link>
                </TrackProvider>
              );
            }
            default:
              return node;
          }
        },
      });

const DynamicForm = ({
  id,
  handleSubmit,
  isSubmitting,
  isModal,
  formData,
  formFields,
  children,
  childrenBeforeFieldName,
  gridGap = ['15px', '20px'],
  formContent,
  ...props
}: any) => (
  <FormLayout
    {...props}
    id={id}
    isSubmitting={isSubmitting}
    handleSubmit={handleSubmit}
    isModal={isModal}
    gridGap={gridGap}
    formContent={formContent}>
    {formFields?.map((node, index) => {
      const childrenBeforeField =
        childrenBeforeFieldName && node.name === childrenBeforeFieldName ? children : null;

      if (node.name === 'suburbIds') {
        return (
          <React.Fragment key={index}>
            {childrenBeforeField}
            <Field
              {...node}
              index={index}
              component={SuburbIdsField}
              name={node.name}
              cityId={props.cityId}
            />
          </React.Fragment>
        );
      }

      return (
        <React.Fragment key={index}>
          {childrenBeforeField}
          <Field
            {...node}
            index={index}
            component={FormField}
            name={node.name}
            id={node.id}
            label={parseContent(
              ['PLAINTEXT', 'plaintext'].includes(node.type)
                ? node.value || node.title
                : (node.title ?? '')
            )}
            value={node.value}
            type={node.type}
            placeholder={node.placeholder}
            options={(node?.options ?? []).filter(Boolean).map((option) => ({
              inputValue: option?.value,
              inputLabel: option?.title,
              inputSelected: option?.selected,
              inputDisabled: option?.disabled,
            }))}
            data={node.data}
            // convert data attribs to data-xx type to avoid the above showing data="[object object]"
            // {...objectKeysMap(getKeyValuePair(node.data, true), (key) => `data-${key}`)}
            labelSize={node.labelSize}
            description={parseContent(node.description)}
            className={node.className}
            display={node.display}
            {...getKeyValuePair(node.attributes, 'autoComplete')}
          />
        </React.Fragment>
      );
    })}
    {(!childrenBeforeFieldName ||
      !formFields?.some((node) => node.name === childrenBeforeFieldName)) &&
      children}
  </FormLayout>
);

export default DynamicForm;
